/**
 * Returns true if provided color is a valid 6 digit hex color, false otherwise
 */
export function isHexColor(hex: string): boolean {
  const pattern = /^#([a-fA-F0-9]){6}|[a-fA-F0-9]{6}$/;
  return pattern.test(hex);
}

/**
 * Takes in a HEX color value and returns an rgb json object
 * @param hex The hex color (ex: "FEFEFE" or "#FEFEFE", MUST BE 6 CHARS)
 * @returns Object {red: number, green: number, blue: number}
 */
export function convertHexToRGB(hex: string): {
  red: number;
  green: number;
  blue: number;
} {
  if (!isHexColor(hex)) throw Error('Invalid color');
  let stripped = hex;
  if (hex[0] === '#') {
    stripped = hex.substring(1);
  }
  const aRgbHex = stripped.match(/.{1,2}/g);
  if (!aRgbHex) throw Error('Invalid Color');
  const aRgb = [
    parseInt(aRgbHex[0], 16),
    parseInt(aRgbHex[1], 16),
    parseInt(aRgbHex[2], 16),
  ];
  return {
    blue: aRgb[2],
    green: aRgb[1],
    red: aRgb[0],
  };
}

// https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
/**
 * Determine an appropriate color to choose dependong on a given background color
 * @param bgColor The background color we are basing off of (ex: "#FEFEFE")
 * @param lightColor What we want to be returned if we choose the light variant (aka bg is dark)
 * @param darkColor What we want to be return if we choose the dark variant (aka bg is light)
 * @returns the provided light color or dark color
 */
export function pickTextColorBasedOnBgColor<T>(
  bgColor: string,
  lightColor: T,
  darkColor: T,
  threshold = 186
) {
  const rgb = convertHexToRGB(bgColor);
  if (rgb.red * 0.299 + rgb.green * 0.587 + rgb.blue * 0.114 > threshold) {
    return darkColor;
  }
  return lightColor;
}
